import axios from 'axios';
import get from 'lodash/fp/get';
import partial from 'lodash/partial';
import mergeInclude from './mergeInclude';

axios.defaults.withCredentials = true;

const fetchSelfFavorites = async () => {
  const { data: loggedIn } = await axios.get('/user/login_status?_format=json');
  if (parseInt(loggedIn, 10) === 1) {
    const { data: jsonApiData } = await axios.get('/jsonapi');
    const endpoint = get('meta.links.me.href', jsonApiData);
    const response = await axios.get(endpoint, {
      // params: {
      //   include: [
      //     'field_favorites',
      //   ].join(','),
      // },
    });
    const { data: { included, data: { relationships } } } = response;
    const mergeTerm = partial(mergeInclude, relationships, included);
    return {
      fieldFavorites: mergeTerm('field_favorites'),
    };
  }
  return ({});
};

export default fetchSelfFavorites;
